import { Components, Theme } from '@mui/material/styles';

const alertTheme: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: (props) => ({
      padding: props.theme.spacing(1),
      boxShadow: `2px 2px 10px ${props.theme.palette.boxShadowColor}`,
      '& .MuiTypography-root': {
        color: props.theme.palette.corporateBlue,
        fontFamily: props.theme.typography.fontFamily,
        textAlign: 'center',
        fontSize: '16px',
        '&.title': {
          fontWeight: 'bold'
        }
      }
    }),
    standardSuccess: (props) => ({
      // Assume standardInfo colours since we don't have any
      // colours defined in the guidelines for standardSuccess
      background: props.theme.palette.oceanicGreen,
      color: props.theme.palette.corporateBlue,
    }),
    standardInfo: (props) => ({
      borderColor: props.theme.palette.forestGreen,
      background: props.theme.palette.oceanicGreen,
      borderWidth: '1px',
      borderStyle: 'solid',
    }),
    standardWarning: (props) => ({
      borderColor: props.theme.palette.yellow[600],
      background: props.theme.palette.yellow[600],
      borderWidth: '1px',
      borderStyle: 'solid',
    }),
    standardError: (props) => ({
      borderColor: props.theme.palette.red[350],
      background: props.theme.palette.red[350],
      borderWidth: '1px',
      borderStyle: 'solid',
      color: props.theme.palette.red[850],
      ' .MuiTypography-root': {
        color: props.theme.palette.red[850],
      },
      ' .MuiAlert-action .MuiButton-text, .MuiAlert-action .MuiButton-text: hover': {
        color: props.theme.palette.red[850],
        fontWeight: 'bold'
      }
    }),
  },
};

export default alertTheme;
